import { observer } from 'mobx-react-lite'
import { BillingMethodSummaryContainer } from '@/features/billing/components/BillingMethodList/BillingMethodSummaryContainer'
import { type BillingViewModel } from '@/features/jobs/drafting/BillingViewModel'
import {
  AdminBilling,
  Billing,
} from '@/features/jobs/drafting/components/JobCreation/Submission/Billing'

export interface BillingContainerProps {
  vm: BillingViewModel
  compact?: boolean
  testId?: string
}

export const BillingContainer = observer(function BillingContainer({
  vm,
  compact,
  testId,
}: BillingContainerProps) {
  return (
    <Billing
      compact={compact}
      selectedPaymentMethod={
        vm.selectedPaymentMethod && (
          <BillingMethodSummaryContainer
            isDisabled={vm.disabled}
            billingMethod={vm.selectedPaymentMethod}
            testId={testId && `${testId}-selected-payment-method`}
          />
        )
      }
      canChange={vm.canChange}
      isDisabled={vm.disabled}
      onChangePaymentMethod={vm.selectMethod}
      onAddPaymentMethod={vm.newPaymentMethod}
      testId={testId}
    />
  )
})

export interface AdminBillingContainerProps {
  vm: BillingViewModel
}

export const AdminBillingContainer = observer(function AdminBillingContainer({
  vm,
}: AdminBillingContainerProps) {
  return (
    <AdminBilling
      bypassBilling={vm.bypassBilling}
      onBypassBillingChange={vm.setBypassBilling}
    />
  )
})
